import {
  DurationPickerV2,
  InfoPopover,
  useDurationPickerField,
} from '@automata/ui';

import {
  selectFeasibilityStage,
  selectFeasibilityStageMaxComputationTime,
} from '../../features/workflow/selectors';
import { updatePlannerOptions } from '../../features/workflow/workflowSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';

export const MaxComputationTimePicker = () => {
  const dispatch = useAppDispatch();
  const maxComputationTime = useAppSelector(
    selectFeasibilityStageMaxComputationTime
  );
  const feasibilityStage = useAppSelector(selectFeasibilityStage);

  const { breakdown, handleBlur, handleUpdateTime } = useDurationPickerField(
    (newTotalSeconds: number) => {
      // Only update if value is greater than 0 to avoid leaving zeros
      if (newTotalSeconds > 0) {
        dispatch(
          updatePlannerOptions({
            feasibility_stage: {
              ...feasibilityStage, // Preserve all existing feasibility_stage data
              max_computation_time: newTotalSeconds,
            },
          })
        );
      }
    },
    maxComputationTime
  );

  return (
    <DurationPickerV2
      label="Maximum compute time"
      infoPopover={
        <InfoPopover
          title="Maximum compute time"
          copy="This is the maximum computation time allowed for generating the first valid plan. If this time limit is reached before a valid plan is generated, planning will fail. It is recommended to have no limit here and use the global Maximum Planning Time instead."
        />
      }
      hours={breakdown.hours}
      minutes={breakdown.minutes}
      seconds={breakdown.seconds}
      handleBlurParent={handleBlur}
      handleUpdateTime={handleUpdateTime}
    />
  );
};
